import {Injectable} from '@angular/core';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';
import {UmpireOttSegment} from '@tisa-group/models';
import {Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable()
export class OttSegmentService implements CrudService<UmpireOttSegment> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireOttSegment[]>> {
    return this.http
      .get('/ott/segments', {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttSegment>> {
    return this.http
      .get(`/ott/segments/${fetchIdentifier}`, {
        params,
      })
      .pipe(deserialize());
  }

  delete(id: string, params?: JsonApiParams): Observable<void> {
    return this.http.delete(`/ott/segments/${id}`, {params: objectToHttpParams(params)});
  }

  create(
    body: Partial<UmpireOttSegment>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttSegment>> {
    return this.http
      .post('/ott/segments', serialize({stuff: body}), {params})
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireOttSegment>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireOttSegment>> {
    return this.http
      .patch(`/ott/segments/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }
}
